import "./ActivitiesAndActions.module.css";
import Header from "@/reusable_sections/Header";
import ActivitiesHero from "./sections/ActivitiesHero";
import ActivitiesGrid from "./sections/ActivitiesGrid";
import Footer from "@/reusable_sections/Footer";
export default function ActivitiesAndActionsPage() {
  return <div>
      <Header />
      <ActivitiesHero />
      <ActivitiesGrid />
      <Footer />
    </div>;
}